<template>
    <div class="main-page">
        <section class="page-section mb-2">
            <div class="container">
                <div class="grid justify-content-center">
                    <div class="col-12 md:col-7 comp-grid">
                        <template v-if="!loading">
                            <div v-if="linkInvalid" class="card nice-shadow-18">
                                <div>
                                    <div class="text-lg font-bold text-center text-primary mb-3">
                                        Unable to open this offer
                                    </div>
                                    <p>{{ linkErrorMsg }}</p>
                                    <p>Thank You!</p>
                                    <p>Admissions Office</p>
                                </div>
                            </div>
                            <div v-else-if="accepted" class="card nice-shadow-18">
                                <div>
                                    <div class="text-lg font-bold text-center text-primary mb-3">
                                        Offer Accepted
                                    </div>
                                    <p>You have successfully accepted your offer of admission to <strong>{{ offer.programme_title }}</strong>.</p>
                                    <p>You do not need to do this again. If you have any questions, please log in to your admission portal or contact the Admissions Office.</p>
                                    <p>Thank You!</p>
                                    <p>Admissions Office</p>
                                </div>
                            </div>
                            <div v-else class="card nice-shadow-18">
                                <div class="my-3">
                                    <div class="text-lg font-bold text-center text-primary">
                                        Offer of Admission
                                    </div>
                                </div>
                                <Divider></Divider>
                                <div class="grid">
                                    <div class="col-12">
                                        <p>Dear {{ offer.applicant_name }},</p>
                                        <p>Congratulations! You have been offered admission to:</p>
                                        <p class="text-lg font-bold text-primary text-center">{{ offer.programme_title }}</p>
                                        <div v-if="offer.already_accepted" class="card nice-shadow-1 py-3 mb-3" style="background: #f0f9ff;">
                                            <p class="mb-0">You have already accepted this offer. You may confirm your acceptance again below if needed.</p>
                                        </div>
                                        <Divider></Divider>
                                        <div class="field-checkbox">
                                            <Checkbox inputId="confirmTerms" v-model="confirmTerms" :binary="true" />
                                            <label for="confirmTerms" class="ml-2">
                                                I hereby confirm my acceptance of the offer of admission to the Ghana
                                                Communication Technology University (GCTU) and acknowledge that I have
                                                read, understood, and agreed to the terms and conditions of my admission.
                                            </label>
                                        </div>
                                        <div class="text-center my-3">
                                            <Button label="Accept Offer" icon="pi pi-check" :loading="saving"
                                                :disabled="!confirmTerms" @click="acceptOffer()" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="p-3 text-center card nice-shadow-18">
                                <ProgressSpinner style="width: 30px; height: 30px" />
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        name: "acceptOfferPage",
        props: {
            id: {
                type: String,
                default: "",
            },
        },
        data() {
            return {
                loading: true,
                saving: false,
                accepted: false,
                confirmTerms: false,
                linkInvalid: false,
                linkErrorMsg: "",
                offer: {
                    applicant_name: "",
                    programme_title: "",
                    already_accepted: false,
                },
            };
        },
        methods: {
            load() {
                this.loading = true;
                this.linkInvalid = false;
                this.$api.get(`applicants/offeracceptance/${this.id}`).then(
                    (response) => {
                        this.loading = false;
                        this.offer = response.data;
                    },
                    (response) => {
                        this.loading = false;
                        this.linkInvalid = true;
                        const data = response && response.response && response.response.data;
                        this.linkErrorMsg =
                            typeof data === "string" && data
                                ? data
                                : "This offer acceptance link is no longer valid. It may have expired, or the offer it refers to is no longer active. Please contact the Admissions Office for assistance.";
                    }
                );
            },
            acceptOffer() {
                if (!this.confirmTerms) {
                    return;
                }
                this.saving = true;
                this.$api.post(`applicants/offeracceptance/${this.id}`, {}).then(
                    () => {
                        this.saving = false;
                        this.accepted = true;
                    },
                    (response) => {
                        this.saving = false;
                        const data = response && response.response && response.response.data;
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail:
                                typeof data === "string" && data
                                    ? data
                                    : "We could not save your acceptance right now. Please try again shortly.",
                            life: 6000,
                        });
                    }
                );
            },
        },
        async mounted() {
            this.load();
        },
    };
</script>
<style scoped></style>
